import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type DeletePhotoItem = {
  photoId: string;
};

export type DeletePhotoItemParams = RequestConfig<DeletePhotoItem>;

export const deletePhotoItem = async ({
  params,
  config
}: DeletePhotoItemParams) =>
  api.delete(`/api/photos/${params.photoId}`, config);
